import { CheckCircle, XCircle } from "lucide-react";
import { FaRegCircleCheck } from "react-icons/fa6";

interface IntegrationsCardProps {
    onCancel: Function;
    onSave: Function;
    defaultId?: string;
    openModal: boolean;
    backgroundVisible?: boolean;
}

import magikeyLogo from "../../../assets/integrations/icon-magikey.svg";
import staysLogo from "../../../assets/integrations/icon-stays.svg";
import FaWhatsapp from "../../../assets/integrations/icon-whatsapp.svg";
import { MdBlockFlipped } from "react-icons/md";
import { primary, secondary } from "../../../theme";

const integrationLogos: Record<string, string | JSX.Element> = {
    wpp: FaWhatsapp,
    magikey: magikeyLogo,
    stays: staysLogo,
};

const integrationNames: Record<string, string> = {
    wpp: "WhatsApp",
    magikey: "Magikey",
    stays: "Stays",
};

export const IntegrationCards = ({ integration_status }: { integration_status: Record<string, boolean> }) => {
    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: 'center',
                justifyContent: "center",
                gap: "20px",
                marginTop: "20px",
                marginBottom: "20px",
            }}
        >
            {Object.entries(integration_status || {}).map(([key, value]) => (
                <div
                    key={key}
                    style={{
                        backgroundColor: "#fff",
                        borderRadius: "16px",
                        boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
                        display: "flex",
                        padding: "0px 25px",
                        flexDirection: "column",
                        width: "100px",
                        alignItems: "center",
                        transition: "transform 0.2s ease",
                        cursor: "default",
                        border: `${value ? `3px solid ${secondary["light"]}`: ''}`,
                    }}
                    onMouseEnter={(e) => {
                        (e.currentTarget as HTMLDivElement).style.transform = "translateY(-4px)";
                    }}
                    onMouseLeave={(e) => {
                        (e.currentTarget as HTMLDivElement).style.transform = "translateY(0px)";
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: '80px', }}>
                        <img
                            src={integrationLogos?.[key].toString()}
                            alt={key}
                            style={{
                                maxWidth: "40px",
                                maxHeight: integrationNames?.[key] === 'Magikey' ? '40px' : '55px',
                                objectFit: "contain",
                                marginTop: "10px",
                                filter: `${value ? `none`: 'grayscale(100%)'}`,
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: "17px", marginTop: "-8px" }}>
                        {value ? (
                            <FaRegCircleCheck color="#22c55e" size={20} />
                        ) : (
                            <MdBlockFlipped color="#ef4444" size={22} />
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}



